module.exports = __webpack_public_path__ + "static/media/hsc-what-jobs-pay.b1e35d96.jpg";